module.exports = __webpack_public_path__ + "fonts/brlnsr.fe2027c2.ttf";